import { jsx } from "react/jsx-runtime";
import Lottie from "lottie-react";
function Animation({
  data,
  className,
  loop = true,
  autoplay = true,
  width = 400,
  height = 400
}) {
  return /* @__PURE__ */ jsx("div", { className, children: /* @__PURE__ */ jsx(Lottie, { animationData: data, loop, autoplay, style: { width, height } }) });
}
export {
  Animation,
  Animation as default
};
